var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcLight"},[_c('h1',[_vm._v("Resize Test")]),_c('div',{staticClass:"MatcTReeCntr"},[_c('Tree',{attrs:{"value":_vm.tree},on:{"select":_vm.onSelect}})],1),_vm._v(" "+_vm._s(_vm.selection)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }